import { Flex } from "@similarweb/ui-components/foundations";

import { WebsiteKeywordsPage2CompareBar } from "./compare-bar/WebsiteKeywordsPage2CompareBar";
import { WebsiteKeywordsPage2CompetitiveFilter } from "./presets/WebsiteKeywordsPage2CompetitiveFilter";
import { useWebsiteKeywordsPage2Context } from "./WebsiteKeywordsPage2Context";

export const WebsiteKeywordsPage2AboveTableMetrics = () => {
    const { isCompare } = useWebsiteKeywordsPage2Context();

    return (
        <Flex
            flexDirection="column"
            margin="0 0 24px"
        >
            <WebsiteKeywordsPage2CompetitiveFilter />
            {isCompare ? <WebsiteKeywordsPage2CompareBar /> : null}
        </Flex>
    );
};
